import { normalizeCuij } from "@tribunalea/shared";

export function uniqueRelatedExpedientes(relacionados = []) {
  const unique = new Map();

  relacionados.forEach((relacionado, index) => {
    const normalizedCuij = normalizeCuij(relacionado?.cuij);
    const fallback = String(
      relacionado?.preExpId ||
        relacionado?.expId ||
        relacionado?.id ||
        relacionado?.caratula ||
        index,
    ).trim();
    const key = normalizedCuij ? `cuij:${normalizedCuij}` : `other:${fallback}`;
    const previous = unique.get(key);
    const relationTypes = new Set([
      ...(previous?.relationTypes || []),
      ...(relacionado?.tipo ? [relacionado.tipo] : []),
    ]);

    unique.set(key, {
      ...(previous || {}),
      ...relacionado,
      cuij: previous?.cuij || relacionado?.cuij,
      caratula: previous?.caratula || relacionado?.caratula,
      relationTypes: [...relationTypes],
    });
  });

  return [...unique.values()];
}
